export default "__VITE_ASSET__DSkmFoSQ__"